import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import PauseIcon from '@material-ui/icons/Pause';
import StopIcon from '@material-ui/icons/Stop';

import {
    CommunicationMessageTypes, LessonControlMessage, LessonState
} from '../../helpers/constants';
import useCommunicator from '../../hooks/useCommunicator';
import { executorStatusUpdateAC } from '../../store/actions/executor.actions';
import {
    IControlMessage, isLessonControlMessage, isLessonStateControlMessage
} from '../../types/communicator-types';

const Container = styled.div`
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  & > svg {
    font-size: 150px;
    color: rgba(0, 0, 0, 0.4);
  }
`;
const Nothing = styled.div`
  display: none;
`;

export interface IPauseOverlayProps {}

export function PauseOverlay(props: IPauseOverlayProps) {
  const status = useSelector((state: any) => state.executor.status);
  const dispatch = useDispatch();
  const communicator = useCommunicator<IControlMessage>(
    CommunicationMessageTypes.ControlMessage
  );
  const pauseLesson = (newLessonState: any) => {
    dispatch(executorStatusUpdateAC(newLessonState));
  };
  useEffect(() => {
    communicator?.receiveMessage((msg) => {
      if (isLessonStateControlMessage(msg) && msg.lessonState) {
        pauseLesson(msg.lessonState);
      }
      if (
        isLessonControlMessage(msg) &&
        msg.controlMessage === LessonControlMessage.EXIT_PLAYER
      ) {
        window.close();
      }
    });
  }, [communicator]);
  if (status === LessonState.STARTED || status === LessonState.INITIAL) {
    return <Nothing />;
  }
  if (status === LessonState.STOPPED) {
    return (
      <Container>
        <StopIcon />
      </Container>
    );
  }
  return (
    <Container>
      <PauseIcon />
    </Container>
  );
}
